import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import axios from 'axios'

export class ReviewService extends BaseService {
  static async comfirmReview(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/mc-confirm-email`,
        { contractId: params.econtractId, isMerchantAgree: params.isMerchantAgree },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async comfirmReviewMegadoc(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/mc-confirm-email`,
        {
          contractId: params.econtractId,
          isMerchantAgree: params.isMerchantAgree,
          urlS3: params.urlS3,
        },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getLinkPDFBusinessContract(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/get-link-pdf-contract`,
        { contractId: params.contractId, appendixId: params.appendixId },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async comfirmReviewAppendix(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/appendix/v1/mc-confirm-email `,
        {
          contractId: params.contractId,
          appendixId: params.appendixId,
          isMerchantAgree: params.isMerchantAgree,
        },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async comfirmActionAppendix(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/appendix/action-appendix`,
        params.data,
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getApendixById(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/e-contract/get-appendix-by-id`,
        { appendixId: params.appendixId },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getApendixById_V1(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/appendix/v1/detail`,
        { appendixId: params.appendixId },
        {
          headers: {
            Authorization: params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getApendixById_V2(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/appendix/get-appendix`,
        { appendixId: params.appendixId },
        {
          headers: {
            Authorization: params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async checkCodeVerify(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/get-code-verify-on-webview`,
        { codeVerify: params.codeVerify, contractId: params.contractId },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async verifyCode(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.e_scon.check-codeverify-on-web'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getEcontractByID(params = {}) {
    try {
      return await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/detail`,
        { econtractId: params.econtractId },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  static async saveLinkPDF(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_REVIEW ?? process.env.VUE_APP_GET_CCRP_REVIEW}/api/scon/econtract/v1/gen-file-pdf`,
        { econtractId: params.econtractId, urlS3: params.urlS3 },
        {
          headers: {
            Authorization: params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
